import { Box, Typography } from '@mui/material';
import {
  BLOOM_CONFIG,
  BloomStats,
} from '../PerformanceDrawer/performanceDrawerData';
import { pxToRem } from '@geneo2-web/shared-ui';
import { ProgressBar } from '../ProgressBar';
import { LevelRow } from '../LevelRow';
interface BloomItemProps {
  data: BloomStats;
}
export const BloomProgressItem = ({ data }: { data: BloomStats[] }) => {
  const config = BLOOM_CONFIG;

  return (
    <Box display="flex" flexDirection="column" gap={pxToRem(10)}>
      {data.map((item) => {
        const conf = config[item.level];

        return (
          <LevelRow
            key={item.level}
            label={conf.label}
            correct={item.correct}
            total={item.total}
            color={conf.color}
            bgColor={conf.bg}
          />
        );
      })}
    </Box>
  );
};
